<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color} stroke-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 17 22">
    <path
      d="M16.7778 8.51042C16.7778 6.70312 16.0844 4.95833 14.825 3.59375L14.6863 3.44792L14.1703 2.96354L14.015 2.83333C12.5615 1.65104 10.7029 1 8.77783 1C4.36729 1 0.777832 4.36979 0.777832 8.51042C0.777832 12.651 4.13983 15.8021 8.3562 16.0104L8.334 17.7708L5.82083 17.7448L5.80973 18.6042L8.32291 18.6302L8.29517 20.9896L9.21056 21L9.2383 18.6406L11.6627 18.6667V18.4948V17.8906H11.6683V17.8073L9.24385 17.7812L9.26604 16.0052C13.4491 15.7656 16.7723 12.4948 16.7723 8.51042H16.7778ZM8.77783 15.1823C7.81805 15.1823 6.89156 15.0052 6.015 14.6562C5.16618 14.3177 4.40613 13.8385 3.75703 13.224C3.10793 12.6146 2.59198 11.901 2.23692 11.1042C1.86521 10.2812 1.67658 9.41146 1.67658 8.51042C1.67658 7.60938 1.86521 6.73437 2.23692 5.91667C2.59753 5.11979 3.10793 4.40625 3.76258 3.79687C4.41722 3.18229 5.17728 2.70312 6.02055 2.36458C6.89711 2.01562 7.84025 1.84375 8.78338 1.84375C9.72651 1.84375 10.6696 2.01562 11.5462 2.36458C12.395 2.70312 13.1551 3.18229 13.8042 3.79687C14.4533 4.40625 14.9692 5.11979 15.3298 5.91667C15.7015 6.73958 15.8902 7.60938 15.8902 8.51042C15.8902 9.41146 15.7015 10.2865 15.3298 11.1042C14.9692 11.901 14.4588 12.6146 13.8042 13.224C13.1551 13.8385 12.395 14.3177 11.5462 14.6562C10.6696 15.0052 9.73761 15.1823 8.78338 15.1823H8.77783Z"
      :class="colorClass"
      stroke-width="0.3"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
